import React from 'react'
import styledComponents from 'styled-components'
import _ from 'lodash'

import config from '../../../config'

const Logo = () => (
  <LogoLayout>
    <ImageLogoLayout>
      <img src="image/logo.png" alt="Town Portal" />
    </ImageLogoLayout>
    <LogoTitle>Portal {_.capitalize(config.subPrefix)}</LogoTitle>
  </LogoLayout>
)

const LogoTitle = styledComponents.h1`
  margin-top: 0em !important;
  margin-bottom: 0em !important;
`

const ImageLogoLayout = styledComponents.div`
  width: 155px;
`

const LogoLayout = styledComponents.div`
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default Logo



// WEBPACK FOOTER //
// ./src/components/templates/signin/Logo.js